<section class="user-management">
  <header class="page-header">
    <div>
      <h2>{{ 'access.manager.title' | translate }}</h2>
      <p class="intro">{{ 'access.manager.intro' | translate }}</p>
    </div>
    <button mat-stroked-button (click)="back()">
      <span class="material-symbols-outlined">arrow_back</span>
      {{ 'access.manager.back' | translate }}
    </button>
  </header>

  @if (loading()) {
    <p class="muted">{{ 'access.manager.loading' | translate }}</p>
  } @else if (loadError()) {
    <div class="error" role="alert">
      <p>{{ loadError() }}</p>
      <button mat-stroked-button (click)="load()">{{ 'access.manager.retry' | translate }}</button>
    </div>
  } @else {
    <mat-tab-group animationDuration="0ms">
      <mat-tab [label]="('access.manager.users' | translate) + ' (' + activeUsers().length + ')'">
        <div class="toolbar">
          <button mat-flat-button (click)="openForm('add')">
            <span class="material-symbols-outlined">person_add</span>
            {{ 'access.manager.add' | translate }}
          </button>
          @if (activeUsers().length > 0) {
            <input
              class="search"
              type="text"
              [placeholder]="'access.manager.search' | translate"
              [value]="searchTerm()"
              (input)="onSearch($event)"
            />
          }
        </div>

        @if (filteredUsers().length === 0) {
          <p class="empty">
            {{ (activeUsers().length === 0 ? 'access.manager.noUsers' : 'access.manager.noResults') | translate }}
          </p>
        } @else {
          <ul class="user-list">
            @for (user of filteredUsers(); track user.id) {
              <li class="user-card">
                <div class="user-main">
                  <p class="roles">
                    @for (role of user.roles; track role) {
                      <span class="role-chip">{{ roleName(role) }}</span>
                    }
                  </p>
                  <div class="identity">
                    <h3>{{ user.displayName ?? user.email }}</h3>
                    @if (user.displayName) {
                      <p class="muted">{{ user.email }}</p>
                    }
                  </div>
                  <p class="muted">
                    @if (user.linked) {
                      {{ 'access.manager.lastSeen' | translate }}: {{ user.lastSeenAt | date: 'd MMM y' }}
                    } @else {
                      {{ 'access.manager.neverSignedIn' | translate }}
                    }
                  </p>
                </div>
                <div class="user-actions">
                  <button mat-stroked-button (click)="openForm('edit', user)">
                    <span class="material-symbols-outlined">edit</span>
                    {{ 'access.manager.edit' | translate }}
                  </button>
                  <button mat-button (click)="remove(user)" [attr.aria-label]="('access.manager.delete' | translate) + ' ' + user.email">
                    <span class="material-symbols-outlined">delete</span>
                    {{ 'access.manager.delete' | translate }}
                  </button>
                </div>
              </li>
            }
          </ul>
        }
      </mat-tab>

      <mat-tab [label]="('access.manager.requests' | translate) + ' (' + requests().length + ')'">
        @if (requests().length === 0) {
          <p class="empty">{{ 'access.manager.noRequests' | translate }}</p>
        } @else {
          <ul class="user-list">
            @for (user of requests(); track user.id) {
              <li class="user-card">
                <div class="user-main">
                  <h3>{{ user.displayName ?? user.email }}</h3>
                  @if (user.displayName) {
                    <p class="muted">{{ user.email }}</p>
                  }
                  <p class="muted">{{ 'access.manager.requestedOn' | translate }} {{ user.createdAt | date: 'd MMM y' }}</p>
                </div>
                <div class="user-actions">
                  <button mat-flat-button (click)="openForm('approve', user)">
                    <span class="material-symbols-outlined">check</span>
                    {{ 'access.manager.approve' | translate }}
                  </button>
                  <button mat-button (click)="remove(user)">{{ 'access.manager.reject' | translate }}</button>
                </div>
              </li>
            }
          </ul>
        }
      </mat-tab>
    </mat-tab-group>
  }
</section>
